// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueSession from 'vue-session'
import Vuetify from 'vuetify'
import store from '@/store/store'
import { sync } from 'vuex-router-sync'
// index.js or main.js

Vue.use(VueResource)
Vue.use(VueSession)
Vue.use(Vuetify)
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
Vue.config.productionTip = false
//import VueCharts from 'vue-chartjs' //FIXME: not being used
//import { Bar, Line } from 'vue-chartjs'

import VDragged from 'v-dragged'
Vue.use(VDragged)

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

sync(store, router)

//var url = 'http://localhost:8082' // for development
var url = 'http://app.decspacedev.sysresearch.org/api' // for production
store.dispatch('setServerHttpUrl', url);

import LineChart from './components/Graphics/LineChart' // TODO:
import BarChart from './components/Graphics/BarChart'
import Doughnut from './components/Graphics/Doughnut'
import BubbleChart from './components/Graphics/BubbleChart'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, LineChart, BarChart, Doughnut, BubbleChart},
  template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js